export const MESSAGES: Messages = {
  CREATE: {
    SUCCESS: {
      variant: "default",
      description: "Conta Contábil criada com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao criar conta contábil.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  UPDATE: {
    SUCCESS: {
      variant: "default",
      description: "Conta Contábil atualizada com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao atualizar conta contábil.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  DISABLED: {
    SUCCESS: {
      variant: "default",
      description: "Operação realizada com sucesso na conta contábil!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao realizar a operação na conta contábil.",
      duration: 5000,
      closeOnClick: true,
    },
  },
};
